function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27.65.7H2.31a.52.52 0 00-.53.53v28a.51.51 0 00.53.52h25.36a.51.51 0 00.53-.52v-28a.59.59 0 00-.55-.53zM16 19.81l-1.9 1.65v-1.71l2-1.67zm-2-3.13L16 15v1.73l-2 1.69zm2-3.07l-2 1.71v-1.71l2-1.71v1.71zm0-3.09l-2 1.73v-1.71l2-1.73zm0-3.09l-2 1.75V7.47l2-1.75zm-2.1-5.66h1.48L14 3zM16 4.32l-2 1.77V4.38l2-1.78zm-1.9 18.52l1.9-1.65v1.73l-1.9 1.63zm0 3.06l1.9-1.62V26l-1.88 1.61zm.38 2.76L16 27.37v1.29zm-11.69 0V1.75h10.1l.21 23.67v3h-.06l.06.06v.06H2.83zm24.3 0H17.07V1.75h10.06z"
})));